import {Kind, print} from 'graphql';

import type {
  DocumentNode,
  FragmentDefinitionNode,
  OperationDefinitionNode,
  SelectionNode,
  VariableDefinitionNode,
} from 'graphql';

export function getOperationName(operation: OperationDefinitionNode): string {
  if (!operation.name) {
    throw new Error(
      `Cannot get an operation name from an anonymous operation.`,
    );
  }

  return operation.name.value;
}

export function getQueryName(document: DocumentNode): string {
  const queryDefinition = document.definitions.find(
    (def): def is OperationDefinitionNode =>
      def.kind === Kind.OPERATION_DEFINITION && def.operation === 'query',
  );

  if (!queryDefinition) {
    throw new Error(
      `There is no query defined on this document: ${print(document)}`,
    );
  }

  return getOperationName(queryDefinition);
}

function createQueryOperationNode(
  name: string,
  topLevelVariableDefinitions: ReadonlyArray<VariableDefinitionNode>,
  topLevelFields: ReadonlyArray<SelectionNode>,
): OperationDefinitionNode {
  return {
    kind: Kind.OPERATION_DEFINITION,
    operation: 'query',
    name: {
      kind: Kind.NAME,
      value: name,
    },
    variableDefinitions: topLevelVariableDefinitions,
    directives: [],
    selectionSet: {
      kind: Kind.SELECTION_SET,
      selections: topLevelFields,
    },
  };
}

export function createQueryDocument(
  queryName: string,
  queryVariablesDefinitions: ReadonlyArray<VariableDefinitionNode>,
  queryFields: ReadonlyArray<SelectionNode>,
  fragmentDefinitions: ReadonlyArray<FragmentDefinitionNode>,
): DocumentNode {
  const queryOperationNode = createQueryOperationNode(
    queryName,
    queryVariablesDefinitions,
    queryFields,
  );

  return {
    kind: Kind.DOCUMENT,
    definitions: [queryOperationNode, ...fragmentDefinitions],
  };
}
